import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { AuthenticationService } from '../service/auth.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
            const ignore401 = request.headers.has('ignore401');
            if (err.status === 401 && !ignore401) {
                // auto logout if 401 response returned from api
                this.authenticationService.logout();
                //location.reload();
            }

            // let error = err.error.errors && err.error.errors.length > 0 ? err.error.errors[0].error : err.statusText || err.statusText;

            // error = err.error.errors && err.error.errors.length > 0 && err.error.errors[0].message == 'INVALID_NIF' ? err.error.errors[0].message : error;
            //!const error = err.error.errors && err.error.errors.length > 0 ? err.error.errors[0].error : err.statusText || err.message;
            const error = err.error.errors && err.error.errors.length > 0 ? err.error.errors[0] : err.statusText || err.message;
            console.log("error")
            console.log(error)
            return throwError(error);
        }));
    }
}
